import App from "@fto-consult/expo-ui";
import config from "./src/config";

App({config});